import { render, staticRenderFns } from "./ProductInstancesSearchForm.vue?vue&type=template&id=5371d8dc&"
import script from "./ProductInstancesSearchForm.vue?vue&type=script&lang=js&"
export * from "./ProductInstancesSearchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports